export default __webpack_public_path__ + "static/media/Ies_Panel1_Movil.63b19316.jpg";